/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesempty1Inputs */

const en_filesempty1 = /** @type {(inputs: Filesempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No files yet. Drop contracts, invoices, photos of defects, or your WhatsApp export. AI will categorize them and pull dated events into the timeline.`)
};

const pt_filesempty1 = /** @type {(inputs: Filesempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda sem ficheiros. Largue contratos, faturas, fotos de defeitos, ou a exportação de WhatsApp. A IA categoriza e extrai eventos com data para a cronologia.`)
};

/**
* | output |
* | --- |
* | "No files yet. Drop contracts, invoices, photos of defects, or your WhatsApp export. AI will categorize them and pull dated events into the timeline." |
*
* @param {Filesempty1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesempty1 = /** @type {((inputs?: Filesempty1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesempty1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesempty1(inputs)
	return pt_filesempty1(inputs)
});
export { filesempty1 as "filesEmpty" }